export function companyToSelectOptions(
  options: { BpID?: string; CNPJ: string; companyName: string }[]
) {
  return options
    .filter((op) => !!op?.CNPJ)
    .map((op) => ({
      value: String(op.CNPJ),
      label: op.companyName,
    }));
}

export function addressToSelectOptions(
  op?: { id: string; street: string; city: string; UF: string }[]
) {
  return (
    op?.map((option) => ({
      value: String(option.id),
      label: `${option.street} - ${option.city} - ${option.UF}`,
    })) || []
  );
}

export function basisToSelectOptions(
  // 1. Tornamos o parâmetro opcional com '?' e tipamos as propriedades como string
  op?: { shippingPoint: string; name: string; branchName: string }[]
) {
  // 2. Usamos Optional Chaining (op?.) para só mapear se existir
  // 3. Usamos o Operador Nullish Coalescing (|| []) para retornar um array vazio caso op seja nulo
  return (
    op?.map((option) => ({
      value: `${option.shippingPoint}-${option.branchName}`,
      label: `${option.name} - ${option.branchName}`,
    })) || []
  );
}
